import React, {useState, useEffect} from 'react';
import Text from '../../../Formatting/Text';

const Help = ({help, value}) => {
    const [helpText, setHelpText] = useState(typeof help === 'string' ? help : null);

    useEffect(() => {
        if (typeof help === 'function') {
            setHelpText(help(value));
        }
        if (typeof help === 'string' || typeof help === 'object') {
            setHelpText(help);
        }
    }, [help, value]);

    if (!helpText) {
        return null;
    }

    return <p className="mt-2 text-xs text-muted text-left px-2">
        <Text>{helpText}</Text>
    </p>
}

export default Help;
